<template>
    <div>
        <div class="input-container ">
            <label for="family-nome">{{label}}</label>
            <input type="text" v-model="innerValue" 
                :class="{'parsley-error': errors && errors.length > 0}"
                :maxlength="maxLength != 0 ? maxLength : 0"
                :disabled="readOnly">
            <ul class="parsley-errors-list filled" id="parsley-id-18"
                v-if="errors && errors.length > 0">
                <li v-for="(error, index) in errors" :key="index" 
                    class="parsley-required">{{error}}</li>
            </ul>            
        </div>
    </div>
</template>

<script>
export default{
    props: {
        label: String,
        value: String,
        maxLength: Number,
        required: Boolean,
        errors: Array,
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            innerValue: this.value
        }
    },
    watch: {
        innerValue(newVal, oldVal){
            this.$emit("input", newVal);
        }
    }
}
</script>

